import React from 'react'

const Price = ({ value }) => {
  return (
    <span>
      {`${value}`.replace('.', ',')}
&nbsp;Euro
    </span>
  )
}

export { Price as default }



// WEBPACK FOOTER //
// ./src/frontend/base/components/Price.js